(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["syndicate-edition"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.syndicate-edition').forEach(function (root) {
    var box = root.querySelector('[data-syndicate-lightbox]');
    if (!box) return;
    var img = box.querySelector('.syndicate-edition__lightbox-img');
    var closeBtn = box.querySelector('[data-syndicate-lightbox-close]');
    function open(src) { img.src = src; box.hidden = false; document.documentElement.style.overflow = 'hidden'; }
    function close() { box.hidden = true; img.src = ''; document.documentElement.style.overflow = ''; }
    root.querySelectorAll('[data-syndicate-zoom]').forEach(function (btn) {
      btn.addEventListener('click', function () { open(btn.getAttribute('data-syndicate-zoom')); });
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) close(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["syndicate-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.syndicate-gallery').forEach(function (root) {
    var box = root.querySelector('[data-syndicate-lightbox]');
    if (!box) return;
    var img = box.querySelector('.syndicate-gallery__lightbox-img');
    var closeBtn = box.querySelector('[data-syndicate-lightbox-close]');

    function open(src) {
      img.src = src;
      box.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      box.hidden = true;
      img.src = '';
      document.documentElement.style.overflow = '';
    }

    root.querySelectorAll('[data-syndicate-zoom]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        open(btn.getAttribute('data-syndicate-zoom'));
      });
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    box.addEventListener('click', function (e) {
      if (e.target === box) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !box.hidden) close();
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
